import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/clients/client";
import { Request } from "types/request";
import { Response } from "types/response"; 

export type ResetPasswordInputs = {
  userId: number;
  subscriptionId: number;
};

export default function useResetPassword() {
  const queryClient = useQueryClient();

  const resetPassword = (resetPassword: ResetPasswordInputs) => {
    const request: Request = {
      url: `${ENDPOINTS.subscription.resetPassword}`,
      config: {
        method: "patch",
        data: resetPassword,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    ResetPasswordInputs
  >(resetPassword, {
    onSettled: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey.toString().startsWith(ENDPOINTS.subscription.main),
      });
      queryClient.invalidateQueries([ENDPOINTS.subscription.main]);
    },
  });

  return { data, mutate, ...rest };
}
